import { groupedOptionValue, QuestionOptionGroup } from "@/types/agent"

import { PillSelector } from "@/components/ui/pill-selector"

type QuestionPillsInputCommonProps = {
  disabled?: boolean
  options: string[]
}

type QuestionPillsSingleSelectProps = QuestionPillsInputCommonProps & {
  selectionMode?: "single"
  value: string | undefined
  onChange: (value: string) => void
  defaultValue?: string
  optionGroups?: QuestionOptionGroup[]
}

type QuestionPillsMultiSelectProps = QuestionPillsInputCommonProps & {
  selectionMode: "multiple"
  value: string[]
  onChange: (value: string[]) => void
}

type QuestionPillsInputProps =
  | QuestionPillsSingleSelectProps
  | QuestionPillsMultiSelectProps

export function QuestionPillsInput(props: QuestionPillsInputProps) {
  if (props.selectionMode === "multiple") {
    return (
      <PillSelector
        selectionMode="multiple"
        options={props.options}
        value={props.value}
        onChange={props.onChange}
        disabled={props.disabled}
        size="sm"
        selectedStyle="border"
      />
    )
  }

  const selectedValue = props.value ?? props.defaultValue ?? ""

  if (props.optionGroups?.length) {
    return (
      <div className="flex flex-col gap-4">
        {props.optionGroups.map((group) => (
          <div key={group.label}>
            <div className="mb-2 text-xs font-medium text-muted">
              {group.label}
            </div>
            <PillSelector
              options={group.options.map((option) => ({
                value: groupedOptionValue(group.label, option),
                label: option,
              }))}
              value={selectedValue}
              onChange={props.onChange}
              disabled={props.disabled}
              size="sm"
              selectedStyle="border"
            />
          </div>
        ))}
      </div>
    )
  }

  return (
    <PillSelector
      options={props.options}
      value={selectedValue}
      onChange={props.onChange}
      disabled={props.disabled}
      size="sm"
      selectedStyle="border"
    />
  )
}
